module.exports = __webpack_public_path__ + "static/media/logo-mxc.52fc313f.png";